<template>
  <div class="grid grid-flow-col grid-cols-8 gap-x-2">
    <label v-if="label" :for="id" class="flex leading-8 col-span-2">{{ label }}</label>
    <input
      :id="id"
      type="number"
      :value="modelValue"
      @change="changeValue"
      class="text-xxs h-8 col-span-2 relative px-1 rounded focus:border-indigo-600 focus:outline-none w-full border border-gray-100 bg-gray-100 cursor-default"
      autocomplete="off"
      :step="step"
    >
    <input
      :id="id"
      type="range"
      :value="modelValue"
      @change="changeValue"
      class="col-span-4 rounded overflow-hidden appearance-none bg-gray-100 h-8"
      :min="min"
      :max="max"
      :step="step"
    >
  </div>
</template>

<script>
export default {
  name: "InputText",
  props:
  [
    "id",
    "label",
    "modelValue",
    "type",
    "mainSelectedNode",
    "propertyName",
    "min",
    "max",
    "step"
  ],
  
  methods: {
    changeValue(event) {
      this.$emit('changeValue', event, this.propertyName)
    }
  }
};
</script>
<style scoped>

  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    input[type="range"]::-webkit-slider-thumb {
      width: 10px;
      -webkit-appearance: none;
      appearance: none;
      height: 32px;
      cursor: ew-resize;
      background: #4f46e5;
      box-shadow: -405px 0 0 400px #F3F4F6;
      border-radius: 0.25rem;
    }
  }
</style>
